import {BaseBilling} from 'app/components/entities/billing/base/model';
import {capitalize, pluralizeN} from 'app/components/helpers/commonHelpers';

export function formatBillingPeriod({count, interval}: BaseBilling.Config): string {
  return count === 1 ? `per ${interval}` : `every ${count}  ${pluralizeN(interval, count)}`;
}

export function formatPrice(amount: number, fraction = 0): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  }).format(amount);
}

export function formatHours(hours: number, fraction = 2): string {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: fraction,
  }).format(hours);
}

export function formatTrialSeconds(seconds: number): string {
  if (seconds < 60) {
    return 'less than a minute';
  }

  const minutes = Math.trunc(seconds / 60);

  if (minutes < 60) {
    return `${minutes} ${pluralizeN('minute', minutes)} `;
  }

  const hours = Math.round(minutes / 60);
  return `${hours} ${pluralizeN('hour', hours)}`;
}

export function formatCouponValue(coupon: BaseBilling.Coupon) {
  if (coupon.amount) {
    return formatPrice(coupon.amount);
  }

  if (coupon.percent_off) {
    return `${coupon.percent_off}%`;
  }

  return coupon.balance ?? '';
}

export function formatCouponError(coupon: BaseBilling.InvalidCoupon): string {
  const {error, conflict} = coupon;

  switch (error) {
    case 'already_used':
      return 'Coupon already used';
    case 'cannot_use':
      if (conflict) {
        return `Cannot use coupon. ${pluralizeN('Subscription', conflict.length)} for ${conflict
          .map(capitalize)
          .join(', ')} already exist${conflict.length > 1 ? '' : 's'}`;
      }

      return 'Cannot use coupon';
    case 'no_uses_left':
      return 'Coupon has expired or cannot be redeemed anymore';
    case 'misconfigured':
      return 'Unsupported coupon. Please contact customer support.';
    default:
      return 'Invalid coupon';
  }
}
